/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_ShareInputs */

const en_us2_wrapped_share = /** @type {(inputs: Wrapped_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share`)
};

const pt_br2_wrapped_share = /** @type {(inputs: Wrapped_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhar`)
};

const es_419_wrapped_share = /** @type {(inputs: Wrapped_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir`)
};

const pt_pt2_wrapped_share = /** @type {(inputs: Wrapped_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partilhar`)
};

const fr_fr2_wrapped_share = /** @type {(inputs: Wrapped_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager`)
};

const de_de2_wrapped_share = /** @type {(inputs: Wrapped_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen`)
};

const it_it2_wrapped_share = /** @type {(inputs: Wrapped_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi`)
};

/**
* | output |
* | --- |
* | "Share" |
*
* @param {Wrapped_ShareInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_share = /** @type {((inputs?: Wrapped_ShareInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_ShareInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_share(inputs)
	if (locale === "es-419") return es_419_wrapped_share(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_share(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_share(inputs)
	if (locale === "de-DE") return de_de2_wrapped_share(inputs)
	if (locale === "it-IT") return it_it2_wrapped_share(inputs)
	return en_us2_wrapped_share(inputs)
});
export { wrapped_share as "wrapped.share" }